<template>
    <div>
        <div class="all_rsya_container gap-1">
            <all-rsy-ad v-for="ad in tableData" :key="ad.id" :ad="ad" class="rsya_item"></all-rsy-ad>
        </div>
    </div>
</template>

<script>
import AllRsyAd from "./AllRsyAd.vue";

export default {
    name: "AllRsyAdsContainer",
    components: {
        AllRsyAd,
    },
    props: ["tableData"]
}
</script>

<style scoped>
    .all_rsya_container {
        font-style: normal;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    @media only screen and (max-width: 600px) {
        .all_rsya_container {
            justify-content: space-around;
        }
    }
</style>
